import GenericDictionaryPage from "./GenericDictionaryPage";
import { getClaimFollowUpType } from "../api/claimFollowUpType";

export default function ClaimFollowUpType() {
    return (
        <GenericDictionaryPage
            tableKey="claimFollowUpType"
            fetchData={getClaimFollowUpType}
            titleKey="genericDic:claimFollowUpType"
            newButtonLabel={({ t }) =>
                t("genericDic:claimFollowUpTypeNew", {
                    tableName: t("genericDic:claimFollowUpType").toLowerCase()
                })
            }
        /> 
    );
}
